// From iOS 13 iPad started to use mac os user-agent.
export const IS_IPAD = navigator.userAgent.includes('Mac') && ('ontouchend' in window || navigator.maxTouchPoints > 0);

export const IS_MOBILE =
  /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(window.navigator.userAgent) || IS_IPAD;

export const IS_APPLE_DEVICE = /iPhone|iPad|iPod|Macintosh/i.test(window.navigator.userAgent);

export const IS_ANDROID_DEVICE = /Android/i.test(window.navigator.userAgent);
